var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CollegeView01'),_c('ForLink',{ref:"forLink",staticClass:"mt20 mb20",attrs:{"queryRang":3}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }